import { DocumentosTab } from '@/features/documentos';

export default function Documentos() {
  return <DocumentosTab />;
}
